import services from './services';
import {
  lg,
  cloneDeep,
  util,
  isCorrectVal,
  isDate
} from 'utils';
import NProgress from 'nprogress';
import $http from '$http';
export default {
  mixins: [services],
  data() {
    return {
      DialogVisible: false,
      loading: false,
      title: "发货通知查看(海信)",
      PictureVisible: false,
      dialogImageUrl: "",
      Form: {},
      OrderInfo: {},
      SendId: ''
    }
  },
  methods: {
    viewSure() {
      this.DialogVisible = false
    },
    printSendGooods() {
      // 区分入口
      let path = this.$route.path
      if (path == '/Family/SendNoticePackage') {
        // 资源包
        util.redirect(this, '/Family/SendNoticePackage/SendNoticePrint?Id=' + this.SendId, false);
      } else if (path == '/Family/SendNoticeHX') {
        // 海信
        util.redirect(this, '/Family/SendNoticeHX/SendNoticePrint?Id=' + this.SendId, false);

      } else if (path == '/Family/SendNoticeStoreHouse') {
        // 仓库
        util.redirect(this, '/Family/SendNoticeStoreHouse/SendNoticePrint?Id=' + this.SendId, false);
      }

      this.viewSure();
    },
    show(opts) {
      this.DialogVisible = true
      this.title = opts.title
      this.SendId = opts.SendId
      this.getById(opts.SendId)
    },

  },


}


// WEBPACK FOOTER //
// ./src/pages/Family/SendNotice/ViewPage/vm.js